import * as React from 'react';
import {View} from "react-native";
import {useState} from "react";
import {Button, TextInput} from "react-native-paper";
import {useNavigation} from "@react-navigation/native";
import {SCREEN_NAMES} from "../routes";

export const DebugUrlOtp = () => {
    const navigation = useNavigation();
    const [transactionId, setTransactionId] = useState<string>('');

    const onNavigateToGuestOrderDetails = () => {
        // @ts-ignore
        navigation.navigate(SCREEN_NAMES.ONE_TIME_PASSWORD, {transactionId});
    };

    return (
        <View style={{margin: 10}}>
            <View style={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>
                <TextInput mode={'outlined'} label={'Transaction ID'} value={transactionId}
                           style={{flex: 10}}
                           onChangeText={setTransactionId}/>
                <Button onPress={onNavigateToGuestOrderDetails} mode={'contained'} style={{flex: 2, minWidth: 175, marginLeft: 5}}>Go
                    To Guest Order</Button>
            </View>
        </View>
    );
};
